import React, { Component } from 'react';
import { Tabs } from '@redux-devtools/ui';
import Themes from './Themes.js';
import StateTree from './StateTree.js';
export default class Settings extends Component {
    constructor() {
        super(...arguments);
        this.state = { selected: undefined };
        this.handleSelect = (selected) => {
            this.setState({ selected });
        };
    }
    render() {
        const { extraTabs = [] } = this.props;
        const tabs = [
            ...extraTabs,
            { name: 'Themes', component: Themes },
            { name: 'State Tree', component: StateTree },
        ];
        return (
        // eslint-disable-next-line @typescript-eslint/no-empty-object-type
        React.createElement(Tabs, { tabs: tabs, selected: this.state.selected || tabs[0].name, onClick: this.handleSelect }));
    }
}
